import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AddFoodCardFailureReasonDialogService } from '@libs/shared/ui/dialogs/add-food-card-failure-reason-dialog/add-food-card-failure-reason-dialog.service';
import { AddFoodCardFailureReasonDialogComponent } from './add-food-card-failure-reason-dialog.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [AddFoodCardFailureReasonDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatIconModule,
    MatTooltipModule,
  ],
  providers: [AddFoodCardFailureReasonDialogService],
})
export class AddFoodCardFailureReasonDialogModule {
  constructor(
    private _addFoodCardFailureReasonDialogService: AddFoodCardFailureReasonDialogService
  ) {}
}
